import axios from '@/plugins/axiosInstance'
import { socialMedia, googleIntegration } from '@/networking/urlManager'

// Platform URL eşleştirmeleri
const platformEndpoints = {
  6: googleIntegration.disconnect, // Google platformu ID=6
  // Diğer platformlar için buraya eklenebilir
  // 1: facebookIntegration.disconnect, // Meta platformu ID=1 
  // 3: twitterIntegration.disconnect,  // X platformu ID=3
}

/**
 * Disconnects from a platform
 * @param {string} assetId - The asset ID
 * @param {number} platformId - ID of the platform to disconnect
 * @returns {Promise<Object>} API response
 */
export const disconnect = async (assetId, platformId) => {
  try {
    // Platform ID'sine göre doğru endpoint'i seç, yoksa varsayılan olarak socialMedia.disconnect kullan
    const endpoint = platformEndpoints[platformId] || socialMedia.disconnect
    
    const response = await axios.post(endpoint, {
      assetId,
      platformId,
    })
    return response.data
  } catch (error) {
    console.error(`Disconnect error for platform ${platformId}:`, error)
    throw error
  }
}
